export const flagsChangeList = [
  // بیمه
  { flagId: 1136, conflictWith: [2556, 1720, 1721, 1722] },

  // مواجهه با شکست‌ها
  { flagId: 1341, conflictWith: [1695, 1696] },

  // ناراضی از روابط
  { flagId: 1194, conflictWith: [1732, 1734, 1735, 1736] },

  // درگذشت اطرافیان
  { flagId: 1141, conflictWith: [1726, 1728, 1729, 1727] },

  // بیماری اطرافیان
  { flagId: 1195, conflictWith: [1712, 1714, 1715, 1713] },

  // دیدن، شنیدن و خواندن"
  { flagId: 507, conflictWith: [1758, 1756, 461] },
];
export const flagsConflict = {
  "roadmap-3": [
    // پایان‌نامه
    { flagId: 4803, conflictWith: [473, 472, 490, 489] },

    // مهاجر
    { flagId: 2557, conflictWith: [1308, 478] },

    // فکر به مهاجرت
    { flagId: 478, conflictWith: [1308] },

    // تجربه شغلی ثابت
    { flagId: 2100, conflictWith: [465] },

    // تفریح
    { flagId: 1719, conflictWith: [461] },

    // شروع تجربه شغلی
    { flagId: 2102, conflictWith: [468, 508, 494, 1279] },

    // شروع تجربه کاری مرتبط با رشته
    { flagId: 468, conflictWith: [2099] },

    // برنامه‌ریزی برای شغل‌های مختلف
    { flagId: 454, conflictWith: [1761, 467, 508, 1279] },

    // کوچ
    { flagId: 469, conflictWith: [479] },

    // فعالیت داوطلبانه
    { flagId: 470, conflictWith: [504] },

    // دوره کارآموزی
    { flagId: 2099, conflictWith: [494, 467] },

    //کارآموزی مرتبط با رشته
    { flagId: 494, conflictWith: [467] },

    // می‌خوای به رشته‌ات شک کنی؟
    { flagId: 490, conflictWith: [487, 1191] },

    // ازدواج مدرن
    { flagId: 499, conflictWith: [1238, 1237] },

    // درگذشت اطرافیان
    { flagId: 1141, conflictWith: [1726, 1728, 1729, 1727] },

    // ناراضی از روابط
    { flagId: 1194, conflictWith: [1732, 1733, 1734, 1736, 1735] },

    // بیماری اطرافیان
    { flagId: 1195, conflictWith: [1713, 1712, 1714, 1715] },

    // کسب درآمد
    { flagId: 1235, conflictWith: [1759] },

    // توسعه فردی
    { flagId: 1416, conflictWith: [1717, 1745] },

    // فعالیت فریلنسری
    { flagId: 495, conflictWith: [1755] },

    // تحصیلات دانشگاهی
    { flagId: 1842, conflictWith: [482, 2089] },

    // مطالعه کنکور ارشد
    { flagId: 462, conflictWith: [2091] },

    // تصمیم برای ادامه تحصیل در مقطع ارشد
    { flagId: 482, conflictWith: [2091, 2089] },

    // تصمیم برای ادامه تحصیل در مقطع دکتری
    { flagId: 2089, conflictWith: [462] },
  ],

  "roadmap-psychology": [
    // کارآموزی در روانشناسی
    { flagId: 3077, conflictWith: [3110, 2981, 2980, 2976] },

    // ارتقای شغلی در روانشناسی
    { flagId: 3110, conflictWith: [3077, 3076, 1487] },

    // بی‌علاقه به شغل در روانشناسی
    { flagId: 2981, conflictWith: [3077, 3076] },

    // شروع تجربه کار در حوزه روانشناسی
    { flagId: 3076, conflictWith: [2981, 3110, 2980, 2976] },

    // حل چالش‌های کاری در روانشناسی
    { flagId: 2980, conflictWith: [3077, 3076] },

    // کسب درآمد در روانشناسی
    { flagId: 2983, conflictWith: [2978] },

    // افزایش درآمد در روانشناسی
    { flagId: 2978, conflictWith: [2983] },

    // بازنگری مسیر شغلی در روانشناسی
    { flagId: 2976, conflictWith: [3077, 3076] },

    // قوانین کار برای غیرمرتبط‌ها
    { flagId: 1493, conflictWith: [1498] },

    // فرصت‌های شغلی کارشناس روانشناسی
    { flagId: 1498, conflictWith: [1493] },

    // انتخاب حوزه شغلی مورد علاقه در روانشناسی
    { flagId: 1487, conflictWith: [3110] },

    // توسعه‌فردی همراه با مسئولیت‌های مادری در روانشناسی
    { flagId: 1118, conflictWith: [1745] },

    // توسعه‌فردی همراه با مسئولیت‌های پدری
    { flagId: 1745, conflictWith: [1118] },

    // همزمانی تحصیل و اشتغال در روانشناسی و نقش پدری و همسری
    { flagId: 3078, conflictWith: [1504] },

    // همزمانی تحصیل و اشتغال در روانشناسی و نقش مادری و همسری
    { flagId: 1504, conflictWith: [3078] },

    // منابع کنکور ارشد روانشناسی
    { flagId: 1489, conflictWith: [1490, 1491] },

    // منابع کنکور دکتری
    { flagId: 1490, conflictWith: [1489, 2992] },

    // مصاحبه دکتری روانشناسی
    { flagId: 1491, conflictWith: [1489, 2992] },

    // مطالعه کنکور ارشد روانشناسی
    { flagId: 2992, conflictWith: [1490, 1491] },

    // توسعه‌فردی همراه با مسئولیت‌های مادری در روانشناسی
    { flagId: 3204, conflictWith: [3203] },

    // توسعه‌فردی همراه با مسئولیت‌های پدری در روانشناسی
    { flagId: 3203, conflictWith: [3204] },
  ],
};
